import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> BECHIR CHERMITI  </span>
            from <span className="purple"> Sousse, Tunisia</span>
            <br />
            I am currently a freelancer 
            <br />
            I am an engineer graduated from the National Engineering School of Gabes , Tunisia .
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Chess 
            </li>
            <li className="about-activity">
              <ImPointRight /> Going to the gym and have a healthy lifestyle 
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Bechir </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
